import { Config } from '../../config'

export const scilogexConfig: Config = {
  partner: 'scilogex',
  catalog: 'partner',
  displayName: 'Scilogex',
  accentColor: '#FF8739',
  host: 'chairs.scilogex.com',
  extraAttributes: {
  }
}
